import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const FAKE_BASE = 125000; // Số khởi đầu
const BASE_DATE = new Date("2024-01-01"); // Ngày bắt đầu đếm

// Tính số lượt truy cập ảo tích lũy đến hôm nay
const getFakeVisitorCount = () => {
  const stored = localStorage.getItem("fake_visitor_data");
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (stored) {
    const { count, lastDate } = JSON.parse(stored);
    const last = new Date(lastDate);
    const daysDiff = Math.floor((today - last) / (1000 * 60 * 60 * 24));

    if (daysDiff === 0) return count; // Cùng ngày, dùng lại

    // Cộng ngẫu nhiên 100-300 cho mỗi ngày đã qua
    let newCount = count;
    for (let i = 0; i < daysDiff; i++) {
      newCount += Math.floor(Math.random() * 201) + 100;
    }
    localStorage.setItem(
      "fake_visitor_data",
      JSON.stringify({ count: newCount, lastDate: today.toISOString() }),
    );
    return newCount;
  }

  // Lần đầu: tính từ BASE_DATE đến hôm nay
  const totalDays = Math.max(
    0,
    Math.floor((today - BASE_DATE) / (1000 * 60 * 60 * 24)),
  );
  let count = FAKE_BASE;
  for (let i = 0; i < totalDays; i++) {
    count += Math.floor(Math.random() * 201) + 100;
  }
  localStorage.setItem(
    "fake_visitor_data",
    JSON.stringify({ count, lastDate: today.toISOString() }),
  );
  return count;
};

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [visitorCount, setVisitorCount] = useState(0);

  useEffect(() => {
    setVisitorCount(getFakeVisitorCount());
  }, []);

  const formatNumber = (n) => new Intl.NumberFormat("vi-VN").format(n);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h2
              className="footer-brand"
              style={{
                fontSize: "2rem",
                color: "#fff",
                marginBottom: "15px",
                letterSpacing: "2px",
              }}
            >
              XEVF.VN
            </h2>
            <p>
              Đồng hành cùng bạn trên hành trình chọn mua xe VinFast với mức giá
              tốt nhất và dịch vụ tận tâm nhất.
            </p>
            {/* Fake visitor counter */}
            <div className="footer-visitor">
              <span className="footer-visitor-icon">👁</span>
              <span className="footer-visitor-text">
                <strong>{formatNumber(visitorCount)}</strong> lượt truy cập
              </span>
            </div>
          </div>

          <div className="footer-section">
            <h4>Liên Kết</h4>
            <ul>
              <li>
                <Link to="/home">Các Dòng Xe VF</Link>
              </li>
              <li>
                <Link to="/compare">So Sánh Xe</Link>
              </li>
              <li>
                <Link to="/mua-xe-gia-tot">Mua Xe Giá Tốt</Link>
              </li>
              <li>
                <Link to="/huong-dan-mua-xe">Hướng Dẫn Mua Xe</Link>
              </li>
              <li>
                <Link to="/chinh-sach">Chính sách dữ liệu</Link>
              </li>
              <li>
                <Link to="/dieu-khoan">Điều khoản sử dụng</Link>
              </li>
              <li>
                <Link to="/booking">Liên Hệ Sale</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Liên Hệ</h4>
            <p>Bùi Thành Trung</p>
            <p>Điện thoại: 0984 472 080</p>
            <p>Email: luatgiabuithanhtrung@gmail.com</p>
            <p>Địa chỉ: Phường Trung Mỹ Tây, TP Hồ Chí Minh</p>
          </div>

          <div className="footer-section">
            <h4>Kết Nối</h4>
            <div className="social-links">
              <a
                href="https://facebook.com/buitrungnd"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} XEVF.VN. Tất cả các quyền được bảo lưu.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
